import './Card.css'
import Section from '../Section/Section'
import Finalize from '../Finalize/Finalize'
import React from 'react'
import moment from 'moment'
import { GoogleReCaptchaCheckbox } from '@google-recaptcha/react'

const Card = (props) => {
  const [loaded, setLoaded] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [billingItems, setBillingItems] = React.useState([])
  // Stryker disable next-line all
  const [totalItems, setTotalItems] = React.useState([])
  const [formSet, setFormSet] = React.useState(false)
  const [showFinalize, setShowFinalize] = React.useState(false)
  // Stryker disable next-line all
  const [successfulCall, setSuccessfulCall] = React.useState(false)
  const [invoiceTotal, setInvoiceTotal] = React.useState(0)
  const addressInput = React.useRef()
  const cityInput = React.useRef()
  const stateInput = React.useRef()
  const zipInput = React.useRef()
  const sitekey = window._env_ === undefined ? process.env.REACT_APP_RECAPTCHA_KEY : window._env_.RECAPTCHA_KEY
  React.useEffect(() => {
    window.recaptchaSubmit = (token) => {
      setIsLoading(true)
      //TODO: Validate on backend
      const body = {
        token: token,
        recaptchaAction: 'submit'
      }
      const request = new XMLHttpRequest()
      request.open('POST', '/api/recaptcha', true)
      request.setRequestHeader('Content-Type', 'application/json')

      request.onreadystatechange = function () { // Call a function when the state changes.
        setIsLoading(false)
        setLoaded(true)
      }
      // Send request
      request.send(JSON.stringify(body))
    }
    return () => {
      delete window.recaptchaSubmit
    }
  }, [])
  React.useEffect(() => {
    let isSubscribed = true
    const items = []
    if (props.units) {
      items.push([`${props.units} ${!props.unitOfFee ? 'item' : props.unitOfFee}(s) x $${props.amount / props.units}`, `$${props.amount}`])
    } else if (props.duration) {
      const billedHours = props.duration / 60
      items.push([`${billedHours} hour(s) x $${props.amount / billedHours}`, `$${props.amount}`])
    }
    if (props.additional_charges) {
      const additionalCharges = JSON.parse(props.additional_charges)
      const keys = Object.keys(additionalCharges)
      keys.forEach((key) => {
        items.push([key, `$${additionalCharges[key]}`])
      })
    }
    if (isSubscribed) {
      setBillingItems(items)
    }
    return () => { isSubscribed = false }
  }, [props.duration, props.units, props.unitOfFee, props.amount, props.additional_charges])
  React.useEffect(() => {
    let isSubscribed = true
    let total = 0
    const items = []
    billingItems.forEach((billingItem) => {
      total += parseFloat(billingItem[1].replace('$', ''))
    })
    items.push(['Total', `$${total === 0 ? total : total.toFixed(2)}`])
    setInvoiceTotal(total)
    if (isSubscribed) {
      setTotalItems(items)
    }
    return () => { isSubscribed = false }
  }, [billingItems])
  React.useEffect(() => {
    // if (verified || props.test) {
    if (invoiceTotal > 0 && props.jefferson_employee === 'No' && props.heartland_response === '' && !formSet && loaded) {
      setFormSet(true)
      // Add Heartland payment script to the page
      const script = document.createElement('script')
      script.src = 'https://api2.heartlandportico.com/SecureSubmit.v1/token/gp-1.0.1/globalpayments.js'
      script.async = true

      script.onload = () => {
        // Configure account
        const heartlandPkey = window._env_ === undefined ? process.env.REACTAPP_HEARTLAND_PKEY : window._env_.HEARTLAND_PKEY
        window.GlobalPayments.configure({
          publicApiKey: heartlandPkey
        })

        // Create Form
        const cardForm = window.GlobalPayments.creditCard.form('#credit-card')
        const htmlSnippet = document.getElementsByClassName('invoiceDiv')[0].innerHTML
        const htmlEmail = processHtmlSnippet(htmlSnippet)
        cardForm.on('token-success', async (resp) => {
          const body = {
            html: htmlEmail,
            user: props.user,
            created_by: props.sys_created_by,
            current_time: moment().format('MMM Do h:mm a'),
            total: invoiceTotal,
            reservationId: props.reservationId,
            payment_token: resp.paymentReference,
            billing_address: addressInput.current.value,
            city: cityInput.current.value,
            state: stateInput.current.value,
            billing_zip: zipInput.current.value
          }

          const request = new XMLHttpRequest() // eslint-disable-line no-undef
          request.open('POST', '/api/payment', true)
          request.setRequestHeader('Content-Type', 'application/json')

          request.onreadystatechange = function () { // Call a function when the state changes.
            setShowFinalize(true)
            const json = JSON.parse(request.response)
            if (json.responseMessage === 'APPROVAL') {
              setSuccessfulCall(true)
            } else {
              setSuccessfulCall(false)
            }
          }
          // Send request
          request.send(JSON.stringify(body))

        })

        cardForm.on('token-error', (resp) => {
          // TODO: Handle error
          // Stryker disable next-line all
          console.log('ERROR RESPONSE', resp)
        })
      }
      document.body.appendChild(script)
      return () => {
        document.body.removeChild(script)
      }
    }

    if (props.jefferson_employee === 'No' && props.heartland_response !== '') {
      setShowFinalize(true)
      setSuccessfulCall(true)
      const heartlandResponse = JSON.parse(props.heartland_response)

      if (heartlandResponse.responseCode !== '00') {
        setSuccessfulCall(false)
      }
    }
    const recaptcha = document.createElement('script')
    recaptcha.src = 'https://www.google.com/recaptcha/enterprise.js?render=' + sitekey
    document.body.appendChild(recaptcha)
    setIsLoading(false)
    return () => {
      document.body.removeChild(recaptcha);
    }
    // }
  }, [invoiceTotal, formSet, props.heartland_response, props.reservationId, loaded])
  const processHtmlSnippet = (htmlSnippet) => {
    // process Sections
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-lightblue-header"', 'style="width: calc(100% - 20px); padding: 10px; height: 20px; font-size:1 16px; font-weight: 700; background-color: rgb(198, 228, 238)"')
    htmlSnippet = htmlSnippet.replaceAll('class="section-name-header"', 'style="width: 380px; display: flex; align-items: center; padding: 0px"')
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-body-item"', 'style="width: fit-content; height: 30px; font-size: 14px; white-space: nowrap; display: flex; align-items: center; padding: 0px 5px 0px 5px; font-weight: 600"')
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-body-value"', 'style="width: fit-content; height: 30px; text-align: center; display: flex; justify-content: center; flex-direction: column; padding: 0px 5px 0px 5px; font-size: 12px; white-space: nowrap; font-weight: 500"')

    // process Divs
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-name-header"', 'style="width: 380px; display: flex; align-items: center; padding: 0px;"')
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-key-header"', 'style="width: fit-content; height: 30px; font-size: 18px; white-space: nowrap; display: flex; align-items: center; padding: 0px 5px 0px 5px; font-weight: 600;"')
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-divider"', 'style="width: 100%; height: 30px; border-bottom: 1px solid lightgray; position: relative; top: -7px;"')
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-value"', 'style="width: fit-content; height: 50px; text-align: center; display: flex; justify-content: center; flex-direction: column; padding: 0px 5px 0px 5px; font-size: 12px;"')
    htmlSnippet = htmlSnippet.replaceAll('class="invoice-name"', 'style="width: fit-content; white-space: nowrap; font-weight: 700;"')

    return htmlSnippet
  }
  // Stryker disable next-line all
  const startTime = props.start_time && props.start_time.replace('-', '/').replace('-', '/')
  const endTime = props.end_time && props.end_time.replace('-', '/').replace('-', '/')
  return (
    <div className='invoice-card-div'>
      <div id='loading' style={{ display: loaded ? 'none' : 'block' }}>
        <button
          disabled={isLoading ? true : false}
          class="g-recaptcha"
          id="grecaptcha"
          data-sitekey={sitekey}
          data-callback='recaptchaSubmit'
          data-action="submit">Click Here to Verify Recaptcha</button>
      </div>
      <div id='form' style={{ display: loaded ? 'block' : 'none' }}>
        <div className='invoiceDiv'>
          <div className='invoice-name-header'>
            <div className='invoice-key-header'>Reservation Details</div>
            <div className='invoice-divider' />
            <div className='invoice-value' data-testid='requester'>
              <div className='invoice-name'>{props.user}</div>
              <div>({props.sys_created_by})</div>
            </div>
          </div>
          <Section
            header='Details'
            items={[
              ['Equipment Name', props.equipment_type],
              ['Service', props.service_type], ['Reservation Number', props.number],
              ['Date', props.date && new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeZone: 'UTC' }).format(Date.parse(props.date))],
              ['Time', `${props.start_time && Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', timeZone: 'America/New_York' }).format(Date.parse(startTime + ' GMT'))} - ${props.end_time && Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', timeZone: 'America/New_York' }).format(Date.parse(endTime + ' GMT'))}`]
            ]}
          />
          <Section
            header='Billing'
            items={billingItems}
          />
          <Section
            header='Total'
            items={totalItems}
          />
        </div>
        {!showFinalize &&
          <div className='formDiv'>
            <p className='p-card'>P-Card</p>
            <div className='pcard-box'>

              <form id='payment-form' action='/api/payment' method='post'>
                {/* TODO: Edit CSS for form to match the examples */}
                {formSet &&
                  <div id='address'>
                    <div className='row'>
                      <label className='custom-label' htmlFor='billingAddress'>Billing Address <input size={43} ref={addressInput} className='pcardField' id='billingAddress' name='billingAddress' style={{ width: '300px' }} type='string' /></label>
                    </div>

                    <div className='row'>
                      <label className='custom-label' htmlFor='city'>City <input ref={cityInput} className='pcardField' id='city' name='city' type='string' /></label>

                      {/* TODO: Convert to dropdown */}
                      <label className='custom-label' htmlFor='state'>State <input ref={stateInput} className='pcardField' id='state' name='state' type='string' /></label>

                      <label className='custom-label' htmlFor='billing_zip'>Zip Code <input ref={zipInput} className='pcardField' id='billing_zip' name='billing_zip' type='number' /></label>
                    </div>
                  </div>}
                <div id='credit-card' />
              </form>
            </div>
          </div>}

        <Finalize
          showFinalize={showFinalize}
          success={successfulCall}
          user={props.user}
          createdBy={props.sys_created_by}
          currentTime={moment().format('MMM Do h:mm a')}
        />
      </div>
    </div >
  )
}

export default Card
